import * as d3Selection from 'd3-selection'
import {Component} from "../html/component"

const d3=Object.assign({},d3Selection);



class SvgComponent extends Component{

    static type='SvgComponent';

}

export {SvgComponent}

